'use client';
import React from 'react';
import type { OrganizeOptionDataReturn } from '@benzinga/data-option-chain';
import { KPIBox } from '../KPIBox';

interface OptionsSummaryStatsProps {
  optionChainData: OrganizeOptionDataReturn;
}

const OptionsSummaryStats: React.FC<OptionsSummaryStatsProps> = ({ optionChainData }) => {
  const { dataByExpiry } = optionChainData;

  let totalCallVol = 0;
  let totalPutVol = 0;
  let totalCallOI = 0;
  let totalPutOI = 0;

  for (const chains of Object.values(dataByExpiry ?? {})) {
    for (const chain of chains ?? []) {
      for (const call of chain.calls ?? []) {
        totalCallVol += call.volume ?? 0;
        totalCallOI += call.openInterest ?? 0;
      }
      for (const put of chain.puts ?? []) {
        totalPutVol += put.volume ?? 0;
        totalPutOI += put.openInterest ?? 0;
      }
    }
  }

  const pcVol = totalCallVol > 0 ? (totalPutVol / totalCallVol).toFixed(2) : '—';
  const pcOI = totalCallOI > 0 ? (totalPutOI / totalCallOI).toFixed(2) : '—';

  return (
    <div className="grid grid-cols-2 gap-3">
      <KPIBox label="P/C Ratio (Vol)" value={pcVol} />
      <KPIBox label="P/C Ratio (OI)" value={pcOI} />
    </div>
  );
};

export default OptionsSummaryStats;
